<ng-container *transloco="let tr; prefix: 'permissions'; scope: 'permissions'">
  <nz-affix [nzOffsetTop]="0">
    <hx-breadcrumbs></hx-breadcrumbs>
    <nz-page-header nzBackIcon [nzGhost]="false">
      <nz-page-header-title>{{'permissions.title' | transloco}}</nz-page-header-title>
      <!--    <nz-page-header-subtitle>{{permission.type | uiLabel}}</nz-page-header-subtitle>-->
    </nz-page-header>
  </nz-affix>

  <p class="readonly-note" *ngIf="readOnly">{{'permissions.errors.readOnly' | transloco}}</p>

  <form nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="8">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>Ключ</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <nz-select formControlName="key" nzShowSearch nzAllowClear nzPlaceHolder="Выберите ключ" [nzDropdownMatchSelectWidth]="false">
              <nz-option *ngFor="let op of permissionOptions" [nzValue]="op.value" [nzLabel]="op.key | transloco"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col [nzSpan]="4">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>Активный</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <nz-radio-group formControlName="active">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24">Даты</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <nz-range-picker nzShowTime="true" formControlName="dateRange" nzFormat="yyyy-MM-dd HH:mm:ss"></nz-range-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>Группа</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hx-group-select formControlName="groupId"></hx-group-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24">Тип</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <nz-select formControlName="containerClass" nzShowSearch nzAllowClear nzPlaceHolder="Выберите тип">
              <nz-option *ngFor="let op of containerClassOptions" [nzValue]="op" [nzLabel]="op"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzSpan]="12">
        <nz-form-item *ngIf="form.controls.containerClass.value === 'Store'">
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>Магазин</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hx-store-select formControlName="containerId"></hx-store-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item *ngIf="form.controls.containerClass.value === 'User'">
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>Пользователь</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hx-user-select formControlName="containerId"></hx-user-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item *ngIf="form.controls.containerClass.value === 'Organization'">
          <nz-form-label [nzSm]="20" [nzXs]="24" nzRequired>Организация</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hx-org-select formControlName="containerId"></hx-org-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row *ngIf="form.controls.containerClass.value && form.controls.containerClass.value !== 'User'">
      <div nz-col nzSpan="24">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24">Исключения</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hx-user-select *ngIf="form.controls.containerClass.value === 'Store'"
                            [storeId]="form.controls.containerId.value ?? undefined"
                            formControlName="excludeUserIds" [hxMode]="'multiple'"></hx-user-select>
            <hx-user-select *ngIf="form.controls.containerClass.value === 'Organization'"
                            formControlName="excludeUserIds" [hxMode]="'multiple'"></hx-user-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8" *ngIf="form.controls.key.value && keyOptions.includes(form.controls.key.value)">
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label [nzSm]="20" [nzXs]="24">Доступ на ресурс</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <nz-select formControlName="resourceClass" nzShowSearch nzAllowClear nzPlaceHolder="Доступ на ресурс">
              <nz-option *ngFor="let op of resourceClassOptions" [nzValue]="op" [nzLabel]="op"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzSpan]="12">
        <nz-form-item *ngIf="form.controls.resourceClass.value === 'Store'">
          <nz-form-label [nzSm]="20" [nzXs]="24">Магазин</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hx-store-select formControlName="resourceIds" [hxMode]="'multiple'"></hx-store-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item *ngIf="form.controls.resourceClass.value === 'Organization'">
          <nz-form-label [nzSm]="20" [nzXs]="24">Организация</nz-form-label>
          <nz-form-control [nzSm]="20" [nzXs]="24">
            <hx-org-select formControlName="resourceIds" [hxMode]="'multiple'"></hx-org-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-form-item nz-row class="cp_actions">
      <nz-form-control [nzSpan]="14">
        <button type="submit" nz-button nzType="primary" *ngIf="!readOnly">
          <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
        </button>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-container>
